export default "https://cdn-static.gokick.com/assets/94c0a6f1f1290e979b6f5177b757303844c3d722/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";